import { gql } from '@apollo/client'
import { BountyFragment } from '@src/graphql/fragment/bounty'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query GetBounties(
    $filterInput: BountyFilterInput!
    $sortInput: BountySortInput!
    $pagingInput: PagingInput!
  ) {
    getBounties(
      filterInput: $filterInput
      sortInput: $sortInput
      pagingInput: $pagingInput
    ) {
      edges {
        node {
          ...Bounty
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${BountyFragment}
  ${PageInfoFragment}
`
